export const SETTINGS_URL = {
  ROOT: "/settings",
  ORGANIZATION: "/settings/organization",
  LOCATION: "/settings/location",
  MACHINE: "/settings/machine",
  TAXONOMY: "/settings/taxonomy",
  PREFERENCES: "/settings/preferences",
} as const;
